import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import * as models from './agent-list-by-group-manager-ids-api.model';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AgentListByGroupManagerIdsApiService {
  constructor(private http: HttpClient) {}

  public fetch(body) {
    return this.http.post(`${environment.apiUserManagerUrl}/api/agents/getAgentsByGroupIds`, body.groupIds);
  }

  public fetchAgentsParams(params): Observable<models.AgentListByGroupManagerIdsApiResp> {
    params.groupIds = [];
    return this.http.post(`${environment.apiUserManagerUrl}/api/agents/getAgentsByGroupIds`, params);
  }
}
